<template>
  <GlobalLoading :loading="visible" />
  <NuxtLayout v-if="isShow">
    <NuxtPage />
  </NuxtLayout>

  <Toaster position="bottom-right" />
</template>

<script setup lang="ts">
  import { onMounted, ref } from "vue";
  import "vue-sonner/style.css";

  import { useGlobalLoading } from "@/composable/useGlobalLoading";
  import { getCodeMap } from "~/composable/BaseApi";
  
  import { Toaster } from "@/components/ui/sonner";

  const isShow = ref(false);
  
  const { visible } = useGlobalLoading();

  onMounted(async () => {
    await getCodeMap();
    isShow.value = true;
  });

</script>
